export default class formConfig {
  // 企业登记信息 项目信息模块
  static projectInformation() {
    return [
      {
        title: "投资项目统一代码",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "项目类别关联代码：",
            value: "relateCode",
            type: "select",
            width: "50%",
            disabled: true,
            clearable: true,
            optionData: [
              { name: "无", value: "0" },
              { name: "固定资产投资项目", value: "1" }
            ]
          },
          {
            label: "投资项目统一代码：",
            value: "investProjectCode",
            type: "input",
            width: "50%",
            disabled: true
          }
        ]
      },
      {
        title: "行业代码",
        name: "2",
        icon: "",
        formConfigList: [
          {
            label: "项目行业门类：",
            type: "select",
            value: "industryClass",
            disabled: true,
            width: "50%",
            queryParams: {
              url: "/dataDictionaryEntries/DictionaryCombobox",
              zdid: "201610191711290723"
            }
          },
          {
            label: "项目行业分类：",
            value: "industryCode",
            type: "select",
            disabled: true,
            width: "50%"
          }
        ]
      },
      {
        title: "项目类型",
        name: "3",
        icon: "",
        formConfigList: [
          {
            label: "项目名称：",
            value: "prjName",
            type: "input",
            width: "100%",
            disabled: true
          },
          {
            type: "select",
            label: "行政监督部门：",
            value: "regulators",
            queryParams: {
              url: "/regulatorsCombobox",
              processType: "201512011001350003"
            },
            disabled: true
          }
        ]
      },
      {
        title: "建设方（甲方）变更/总包单位项目",
        name: "4",
        icon: "",
        formConfigList: [
          {
            label: "项目名称：",
            value: "firstConstructionPrjName",
            type: "input",
            width: "100%",
            disabled: true
          },
          {
            label: "原建设方（甲方）项目编号：",
            value: "firstConstructionNo",
            type: "input",
            disabled: true
          },
          {
            label: "招标人变更类型：",
            type: "select",
            value: "tenderCorpChangeType",
            queryParams: {
              url: "/dataDictionaryEntries/DictionaryCombobox",
              zdid: "201607071721585823"
            },
            disabled: true
          }
        ]
      },
      {
        title: "现建设单位信息",
        name: "5",
        icon: "",
        formConfigList: [
          {
            label: "现建设单位名称：",
            value: "buildCorpName",
            type: "input",
            disabled: true
          },
          {
            label: "现建设单位组织机构代码：",
            value: "buildCorpCode",
            type: "input",
            disabled: true
          },
          {
            label: "现建设单位地址：",
            value: "buildCorpAddress",
            type: "input",
            disabled: true
          },
          {
            label: "现建设单位法定代表人：",
            value: "buildCorpLegal",
            type: "input",
            disabled: true
          },
          {
            label: "现建设单位单位性质：",
            value: "buildCorpProperty",
            type: "input",
            disabled: true
          },
          {
            label: "现建设单位联系人：",
            value: "buildCorpLinkMan",
            type: "input",
            disabled: true
          },
          {
            label: "现建设单位联系人电话：",
            value: "buildCorpLinkTel",
            type: "input",
            disabled: true
          },
          {
            label: "现建设单位联系人手机：",
            value: "buildCorpLinkMobile",
            type: "input",
            disabled: true
          },
          {
            label: "现建设单位邮编：",
            value: "buildCorpPostalCode",
            type: "input",
            disabled: true
          },
          {
            label: "现建设单位传真：",
            value: "buildCorpFax",
            type: "input",
            disabled: true
          },
          {
            label: "建设单位电子邮件：",
            value: "buildCorpEMail",
            type: "input",
            disabled: true
          }
        ]
      },
      {
        title: "项目基本信息",
        name: "6",
        icon: "",
        formConfigList: [
          {
            label: "项目地点：",
            value: "prjAddress",
            type: "input",
            width: "50%",
            disabled: true
          },
          {
            type: "select",
            label: "项目类别：",
            value: "prjLargeClass",
            clearable: true,
            disabled: true,
            width: "50%",
            queryParams: {
              url: "/dataDictionaryEntries/engineeringCombobox",
              parentId: "0"
            }
          },
          {
            type: "select",
            label: "项目小类：",
            value: "prjCategory",
            clearable: true,
            disabled: true,
            width: "50%",
            queryParams: {
              url: "/dataDictionaryEntries/engineeringCombobox",
              parentId: ""
            }
          },
          {
            label: "立项文号：",
            value: "noteNumber",
            type: "input",
            width: "50%",
            disabled: true
          },
          {
            label: "立项级别：",
            type: "select",
            value: "approveLevel",
            width: "50%",
            disabled: true,
            queryParams: {
              url: "/dataDictionaryEntries/DictionaryCombobox",
              zdid: "201509241722250016"
            }
          },
          {
            label: "立项形式：",
            type: "select",
            value: "approveType",
            width: "50%",
            disabled: true,
            queryParams: {
              url: "/dataDictionaryEntries/DictionaryCombobox",
              zdid: "201509241722460017"
            }
          },
          {
            label: "批准单位：",
            value: "approveUnit",
            type: "input",
            width: "50%",
            disabled: true
          },
          {
            label: "批准投资总额（万元）：",
            value: "totalInvestmentAmount",
            type: "slot",
            slotName: "totalInvestmentAmount",
            width: "50%",
            rule: {
              required: false,
              message: "请输入外资",
              trigger: "blur"
            }
          },
          {
            label: "本年度投资计划（万元）：",
            value: "investmentPlanThisYear",
            type: "slot",
            slotName: "investmentPlanThisYear",
            width: "50%",
            rule: {
              required: false,
              message: "请输入外资",
              trigger: "blur"
            }
          },
          {
            label: "国有盈利性投资（万元）：",
            value: "stateProfitInvestment",
            type: "slot",
            slotName: "stateProfitInvestment",
            width: "50%",
            rule: {
              required: false,
              message: "请输入外资",
              trigger: "blur"
            }
          },
          {
            label: "国有非盈利性投资（万元）：",
            value: "stateNonprofitInvestment",
            type: "slot",
            slotName: "stateNonprofitInvestment",
            width: "50%",
            rule: {
              required: false,
              message: "请输入外资",
              trigger: "blur"
            }
          },
          {
            label: "非国有投资（万元）：",
            value: "nonstateInvestment",
            type: "slot",
            slotName: "nonstateInvestment",
            width: "50%",
            rule: {
              required: false,
              message: "请输入外资",
              trigger: "blur"
            }
          },
          {
            label: "外资（万元）：",
            value: "foreignInvestment",
            type: "slot",
            slotName: "foreignInvestment",
            width: "50%",
            rule: {
              required: false,
              message: "请输入外资",
              trigger: "blur"
            }
          }
        ]
      },
      {
        title: "工程概况",
        name: "7",
        icon: "",
        formConfigList: [
          {
            label: "工程规模：",
            value: "projectScale",
            type: "input",
            width: "50%",
            disabled: true
          },
          {
            label: "项目性质：",
            type: "select",
            value: "constructionType",
            disabled: true,
            width: "50%",
            queryParams: {
              url: "/dataDictionaryEntries/DictionaryCombobox",
              zdid: "201509241722580018"
            }
          },
          {
            label: "项目等级：",
            type: "select",
            value: "constructionGrade",
            disabled: true,
            width: "50%",
            queryParams: {
              url: "/dataDictionaryEntries/DictionaryCombobox",
              zdid: "201509241723100019"
            }
          },
          {
            label: "重点工程：",
            type: "select",
            value: "isKeyProject",
            disabled: true,
            width: "50%",
            queryParams: {
              url: "/dataDictionaryEntries/DictionaryCombobox",
              zdid: "201509241723190020"
            }
          },
          {
            label: "规划建筑层数32层以下：",
            tip: "（栋数）",
            value: "layersFollowingThirtyTwo",
            type: "input",
            width: "50%",
            disabled: true
          },
          {
            label: "规划建筑层数32层（含）以上：",
            tip: "（栋数）",
            value: "layersAboveThirtyTwo",
            type: "input",
            width: "50%",
            disabled: true
          },
          {
            label: "深基坑深度9米以下：",
            tip: "（栋数）",
            value: "depthFollowingNine",
            type: "input",
            width: "50%",
            disabled: true
          },
          {
            label: "深基坑深度9米（含）以上：",
            tip: "（栋数）",
            value: "depthAboveNine",
            type: "input",
            width: "50%",
            disabled: true
          },
          {
            label: "建筑高度100米以下：",
            tip: "（栋数）",
            value: "heightFollowingOneHundred",
            type: "input",
            width: "50%",
            disabled: true
          },
          {
            label: "建筑高度100米（含）以上：",
            tip: "（栋数）",
            value: "heightAboveOneHundred",
            type: "input",
            width: "50%",
            disabled: true
          },
          {
            label: "公共建筑跨度30米以下：",
            value: "spanFollowingThirtyTwo",
            tip: "（厂房、公共设施）（栋数）",
            type: "input",
            width: "50%",
            disabled: true
          },
          {
            label: "公共建筑跨度30米（含）以上：",
            value: "spanAboveThirtyTwo",
            tip: "（厂房、公共设施）（栋数）",
            type: "input",
            width: "50%",
            disabled: true
          },
          {
            label: "是否房地产开发：",
            value: "isRealEstateProject",
            type: "select",
            clearable: true,
            disabled: true,
            width: "50%",
            optionData: [
              { name: "否", value: "0" },
              { name: "是", value: "1" }
            ]
          },
          {
            label: "是否工业项目：",
            value: "isIndustryProject",
            type: "select",
            clearable: true,
            disabled: true,
            width: "50%",
            optionData: [
              { name: "否", value: "0" },
              { name: "是", value: "1" }
            ]
          }
        ]
      },
      {
        title: "备注",
        name: "8",
        icon: "",
        formConfigList: [
          {
            label: "备注信息：",
            value: "description",
            type: "textarea",
            width: "100%",
            disabled: true
          }
        ]
      },
      {
        title: "核验",
        name: "9",
        icon: "",
        formConfigList: [
          {
            label: "核验意见：",
            value: "auditOpinion",
            type: "textarea",
            width: "100%;",
            maxlength: 500,
            disabled: false,
            rule: [
              {
                required: true,
                message: "该输入项不能为空",
                trigger: "blur"
              }
            ]
          }
        ]
      }
    ];
  }
}
